import e from "./ghl-ui.es1506.js";
import u from "./ghl-ui.es1466.js";
function f(r, t) {
  u(2, arguments);
  var a = e(r), o = e(t);
  return a.getFullYear() === o.getFullYear();
}
export {
  f as default
};
